import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=34cf3c96&scoped=true"
import script from "./DashboardButton.vue?vue&type=script&lang=js"
export * from "./DashboardButton.vue?vue&type=script&lang=js"
import style0 from "./DashboardButton.vue?vue&type=style&index=0&id=34cf3c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf3c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
